export const VendorErrorSource = {
  MANUAL: 'MANUAL',
  UNRESOLVED_QUEUE: 'UNRESOLVED_QUEUE',
} as const;

export type VendorErrorSource =
  (typeof VendorErrorSource)[keyof typeof VendorErrorSource];
